import AsyncPage from 'pages/AsyncPage'
import { loadInstanceInfo } from 'state/actions/instance'
import { loadOnboardingTags } from 'state/actions/registration/tags'

import universal from 'react-universal-component'
const component = universal(props => import('./GetStartedPage.js'))

class AsyncGetStartedPage extends AsyncPage {
  constructor() {
    super({
      isChromeless: true,
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const {
      instance: { value: instance },
      registration: { tags: { value: tags } } = {}
    } = getState()
    // in case of a direct landing on the registration screen
    // we need to make sure that the domain-info is available
    if (!tags) {
      await loadOnboardingTags()(dispatch, getState, opts)
    }
  }
}

export default new AsyncGetStartedPage()
